// extracted by mini-css-extract-plugin
module.exports = {"AboutSection":"About_AboutSection__3UN2I","AboutDescription":"About_AboutDescription__38DGU","DescGroup":"About_DescGroup___pvPO","Text":"About_Text__3ROM6"};